<script setup lang="ts">
defineProps<{
  isFirstQuestion: boolean
  isLastQuestion: boolean
  isNextDisabled: boolean
}>()

const emit = defineEmits<{
  prev: []
  next: []
  submit: []
}>()
</script>

<template>
  <div class="navigation-buttons">
    <button class="prev-button" @click="emit('prev')" :disabled="isFirstQuestion">戻る</button>

    <button
      v-if="!isLastQuestion"
      class="next-button"
      @click="emit('next')"
      :disabled="isNextDisabled"
    >
      次へ
    </button>

    <button v-else class="submit-button" @click="emit('submit')" :disabled="isNextDisabled">
      提案を受ける
    </button>
  </div>
</template>

<style lang="scss" scoped>
.navigation-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding: 0 22px;
  width: 100%;
  box-sizing: border-box;
}

.prev-button,
.next-button,
.submit-button {
  padding: 10px 20px;
  width: 40%;
  font-size: 36px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
}

.prev-button {
  background-color: transparent;
  color: #a5dbdf;
  &:hover {
  }
}

.prev-button:hover {
  background-color: transparent;
}

.prev-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.next-button,
.submit-button {
  box-sizing: border-box;
  color: white;
  outline: 2px solid #fff;
  outline-offset: -5px;
  background-color: #36b4a8;
}

.next-button:hover,
.submit-button:hover {
  background-color: #36b4a8;
}

.next-button:disabled,
.submit-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
@media screen and (max-width: 767px) {
  .navigation-buttons {
    padding: 0 10px;
    margin-top: 15px;
  }

  .prev-button,
  .next-button,
  .submit-button {
    padding: 8px 15px;
    font-size: 18px;
    border-radius: 15px;
    width: 45%; // モバイルでのボタン幅を少し広げる
  }
}
</style>
